import { TLandingSettings } from 'types/landing';

import { CRMAPIBase } from '@api/crmApiBase';
import { LandingProductsResp } from '@api/responseModels/landing/landingProductsResponse';
import { LandingPromoResp } from '@api/responseModels/landing/landingPromoResponse';
import { LandingPromosResp } from '@api/responseModels/landing/landingPromosResponse';
import { LandingServicesResp } from '@api/responseModels/landing/landingServicesResponse';
import { LandingSettingsResp } from '@api/responseModels/landing/landingSettingsResponse';
import { LandingWorkerPositionResp } from '@api/responseModels/landing/landingWorkerPositionsResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class LandingGroup extends CRMAPIBase {
    async getLandingProducts(params: {
        crm_id: number;
    }): Promise<RequestResult<LandingProductsResp>> {
        const result = await this.get<LandingProductsResp>(`/landing/products`, params);
        return result;
    }
    async getLandingServices(params: {
        crm_id: number;
    }): Promise<RequestResult<LandingServicesResp>> {
        const result = await this.get<LandingServicesResp>(`/landing/services`, params);
        return result;
    }
    async getLandingWorkerPositions(params: {
        crm_id: number;
    }): Promise<RequestResult<LandingWorkerPositionResp>> {
        const result = await this.get<LandingWorkerPositionResp>(
            `/landing/worker-positions`,
            params
        );
        return result;
    }
    async getLandingPromos(params: { crm_id: number }): Promise<RequestResult<LandingPromosResp>> {
        const result = await this.get<LandingPromosResp>(`/landing/promo`, params);
        return result;
    }
    async getLandingPromo(params: {
        crm_id: number;
        promo_id: number;
    }): Promise<RequestResult<LandingPromoResp>> {
        const result = await this.get<LandingPromoResp>(
            `/landing/promo/${params.promo_id}`,
            params
        );
        return result;
    }
    async updateLandingSettings(
        params: TLandingSettings
    ): Promise<RequestResult<LandingSettingsResp>> {
        const result = await this.post<LandingSettingsResp>(`/landing/updateVisible`, params);
        return result;
    }
}

export { LandingGroup };
